module.exports = __webpack_public_path__ + "media/images/icons/courses/2-5592369c8efa642bd9ce2d98e86b1672.svg";